<template>
  <div>
    <general-table
      :api-url="apiUrl"
      :add-component-name="addComponentName"
      :edit-component="editComponent"
      :delete-content="false"
      :block-content="false"
      :edit-content="true"
      :view-content="false"
      :add-type="addType"
      :viw-component="'show-delegator'"
      :columns="columns"
      :type="type"
    >
      <template #cell(cr)="data">
        <div>
          <a
            v-if="data.item.cr_url"
            :href="data.item.cr_url"
            target="_blank"
            class="text-dark cursor-pointer"
          >
            <feather-icon
              icon="FileIcon"
              size="18"
            />
          </a>
        </div>
      </template>
    </general-table>
  </div>
</template>

<script>
import GeneralTable from '@/components/general-table/GeneralTable.vue'

export default {
  components: { GeneralTable },
  data() {
    return {
      addComponentName: '',
      editComponent: 'edit-importer',
      addType: '',
      type: 'page',
      filter: {},
      loading: false,
      delegatorRole: '',
      columns: [
        { key: 'name', label: 'Name' },
        { key: 'address', label: 'Address' },
        { key: 'commercial_registration', label: 'Commerical Registration' },
        { key: 'nearest_certificate_expiration', label: 'Nearest Certificate Expiration' },
        { key: 'last_request_date', label: 'Last Request Date' },
        { key: 'cr', label: 'Cr' },
        { key: 'actions', label: 'Actions' },
      ],
    }
  },
  computed: {
    apiUrl() {
      const base = 'importers?'
      if (!Object.values(this.filter).length) {
        return base.slice(0, -1)
      }

      const queryParams = Object.entries(this.filter)
        .filter(([key, value]) => key && value)
        .map(([key, value]) => `${key}=${value}`)
        .join('&')

      return `${base}${queryParams}`
    },
  },
  methods: {
    filterTypes(type) {
      this.types = this.status.filter(item => item.text !== type)
    },
  },
}
</script>
